import {
  CACHE_INIT_START,
  CACHE_INIT_SUCCESS,
  CACHE_INIT_ERROR
} from '../constants/ActionTypes';

export const cacheInitStart = () => ({
  type: CACHE_INIT_START
});

export const cacheInitSuccess = () => ({
  type: CACHE_INIT_SUCCESS
});

export const cacheInitError = (error) => ({
  type: CACHE_INIT_ERROR,
  payload: error
});
